import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectReadReceiptOption')(function selectReadReceiptOption(choice, state) {
    var optionState = state.optionState;
    optionState.readReceiptResponse = choice;
}));
//# sourceMappingURL=selectReadReceiptOption.js.map